import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderCell, HeaderRow, Table, Wrapper } from './SingleBlock.styles';
import SingleBlockRow from './SingleBlockRow/SingleBlockRow';
import parseRelatedTopics from '../../../../../../helpers/effectReports/parseRelatedTopics';
import { convertTypeString } from '../../../../../../helpers/helpers';
import { useReportContext } from '../../../../../../hooks/useReport';
import { Analysis } from '../../../../../../services/reports';

interface SingleBlockProps {
  data: Analysis;
}

const SingleBlock: React.FC<SingleBlockProps> = ({ data }) => {
  const { effectData } = useReportContext();
  const matchingTopics = parseRelatedTopics(data, effectData);

  const { t } = useTranslation();

  return (
    <Wrapper>
      {data.included_topics.length < 1 ? null : (
        <>
          <Table>
            <thead>
              <HeaderRow>
                <HeaderCell>{t(`report.effect.topics.${convertTypeString(data.type)}`)}</HeaderCell>
                <HeaderCell>{t('report.effect.table.score')}</HeaderCell>
              </HeaderRow>
            </thead>
            <tbody>
              {matchingTopics.map(topic => (
                <SingleBlockRow key={topic.code} topic={topic} />
              ))}
            </tbody>
          </Table>
        </>
      )}
    </Wrapper>
  );
};

export default SingleBlock;
